// extracted by mini-css-extract-plugin
export default {"snippet-view":"SnippetView_snippet-view__oZMtQ"};